import AlgorithmPage from "../../pages/algorithm/AlgorithmPage";
import ConfiguracionGlobalTalentosPage from "../../pages/configuracionTalentos/ConfiguracionGlobalTalentosPage";
import FrasesPage from "../../pages/frases/FrasesPage";
import FrasesRespuestaPage from "../../pages/frasesRespuesta/FrasesRespuestaPage";
import PlantelConfigurationPage from "../../pages/plantels/PlantelConfigurationPage";
import PlantelsPage from "../../pages/plantels/PlantelsPage";
import SchoolPage from "../../pages/schools/SchoolPage";
import TalentosPage from "../../pages/talentos/TalentosPage";
import UsersPage from "../../pages/UsersPage";
import FortalezasAreasPage from "../../pages/fortalezas/FortalezasAreasPage";
import FortalezasAccionesPage from "../../pages/fortalezas/FortalezasAccionesPage";
import FortalezasPlantelPage from "../../pages/plantels/fortalezas/FortalezasPlantelPage";
import PreguntasConfirmacionPage from "../../pages/preguntasConfirmacion/PreguntasConfirmacionPage";
import FrasesConfirmacionPage from "../../pages/frasesConfirmacion/FrasesConfirmacionPage";
import { ROLES } from "../role.constants";
import PlantelConfirmationPage from "../../pages/plantels/PlantelConfirmationPage";
import PhraseApplicationPage from "../../pages/PhrasesAplication/PhraseApplicationPage";
import ActivitiesApplicationPage from "../../pages/activities-application/ActivitiesApplicationPage";
import PlantelApplicationPage from "../../pages/plantels/PlantelApplicationPage";
import PlantelConversacionesPage from "../../pages/plantels/PlantelConversacionesPage";
import PlantelContenidoConversacionesPage from "../../pages/plantels/PlantelContenidoConversacionesPage";
import CuestionariosListPage from "../../pages/cuestionarios/CuestionariosListPage";
import CuestionarioEditorPage from "../../pages/cuestionarios/CuestionarioEditorPage";
import SeguimientoPage from "../../pages/seguimiento/SeguimientoPage";
import AlumnosSeguimientoPage from "../../pages/seguimiento/AlumnosSeguimientoPage";
import AlumnoDetallePage from "../../pages/seguimiento/AlumnoDetallePage";
import ConversacionesGlobalesPage from "../../pages/conversacionesGlobales/ConversacionesGlobalesPage";
import ContenidoPage from "../../pages/contenido/ContenidoPage";
import RolesPermisosPage from "../../pages/rolesPermisos/RolesPermisosPage";
import ConfirmacionConfigAdPage from "../../pages/configuracionTalentos/ConfirmacionConfigAdPage";
import FortalezaConfigAdPage from "../../pages/configuracionTalentos/FortalezaConfigAdPage";
import AplicacionConfigAdPage from "../../pages/configuracionTalentos/AplicacionConfigAdPage";
import FrasesPreguntasTalentoPage from "../../pages/preguntasTalento/FrasesPage";
import SubFrasesPreguntasTalentoPage from "../../pages/preguntasTalento/SubFrasesPage";
import OpcionesRespuestaPreguntasTalentoPage from "../../pages/preguntasTalento/OpcionesRespuestaPage";
import ConfiguracionAdicionalPreguntasTalentoPage from "../../pages/preguntasTalento/ConfiguracionAdicionalPage";
import PreguntasTalentoPlantelPage from "../../pages/plantels/preguntasTalento/PreguntasTalentoPlantelPage";

export const adminRoutes = [
  {
    path: "/preguntas-talento/frases",
    element: <FrasesPreguntasTalentoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/preguntas-talento/sub-frases",
    element: <SubFrasesPreguntasTalentoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/preguntas-talento/opciones",
    element: <OpcionesRespuestaPreguntasTalentoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/preguntas-talento/configuracion-adicional",
    element: <ConfiguracionAdicionalPreguntasTalentoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-fortalezas-2/:plantelId",
    element: <PreguntasTalentoPlantelPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/usuarios",
    element: <UsersPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/escuelas",
    element: <SchoolPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/planteles",
    element: <PlantelsPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/talentos",
    element: <TalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases",
    element: <FrasesPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases-respuesta",
    element: <FrasesRespuestaPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/configurar-algoritmo",
    element: <AlgorithmPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/configuracion-global-talentos",
    element: <ConfiguracionGlobalTalentosPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-talentos/:plantelId",
    element: <PlantelConfigurationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/configuracion-fortalezas/areas",
    element: <FortalezasAreasPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/configuracion-fortalezas/acciones",
    element: <FortalezasAccionesPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/preguntas-confirmacion",
    element: <PreguntasConfirmacionPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases-confirmacion",
    element: <FrasesConfirmacionPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-confirmación-talentos/:plantelId",
    element: <PlantelConfirmationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-fortalezas-talentos/:plantelId",
    element: <FortalezasPlantelPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/actividades-aplicacion",
    element: <ActivitiesApplicationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/frases-aplicacion",
    element: <PhraseApplicationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-aplicacion-de-talentos/:plantelId",
    element: <PlantelApplicationPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-conversaciones-talentos/:plantelId",
    element: <PlantelConversacionesPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/ver-contenido-conversaciones-talentos/:plantelId",
    element: <PlantelContenidoConversacionesPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/cuestionarios",
    element: <CuestionariosListPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/cuestionarios/nuevo",
    element: <CuestionarioEditorPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/cuestionarios/:id",
    element: <CuestionarioEditorPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/seguimiento-mentores",
    element: <SeguimientoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/mis-alumnos",
    element: <AlumnosSeguimientoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR],
  },
  {
    path: "/mis-alumnos/:id",
    element: <AlumnoDetallePage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR],
  },
  {
    path: "/conversaciones-globales",
    element: <ConversacionesGlobalesPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/conversaciones",
    element: <ContenidoPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/roles-permisos",
    element: <RolesPermisosPage />,
    roles: [ROLES.ADMIN_SYS],
  },
  {
    path: "/confirmacion-config-adicional",
    element: <ConfirmacionConfigAdPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/fortaleza-config-adicional",
    element: <FortalezaConfigAdPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
  {
    path: "/aplicacion-config-adicional",
    element: <AplicacionConfigAdPage />,
    roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
  },
];
